module.exports = __webpack_public_path__ + "static/media/item_6_14_comp.21fdc65b.png";